import React from 'react';
import { Layout } from 'antd';

const AppFooter = () => (
	<Layout.Footer style={{ textAlign: 'center' }}>
		SMApp ©2018 Created by SheCodez | NJN
	</Layout.Footer>
);

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/common/AppFooter.js